export default "__VITE_ASSET__B4j8sFfH__"